<template>
    <div class="page">
      <ion-grid>
        <ion-row class="search-view">
          <ion-col>
            <ion-row align-items-stretch>
              <!-- <ion-col size="12" size-md="2">
                <ion-label>Branch Name</ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    id="branch"
                    @input="branch = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col> -->
              <ion-col size="12" size-md="2">
                <ion-label>Station Name</ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    id="stationName"
                    v-model="stationName"
                    @input="stationName = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="2">
                <ion-label>City</ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    id="city"
                    v-model="city"
                    @input="city = $event.target.value"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="2">
                <ion-label>Chargebox ID</ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    id="chargeboxId"
                    v-model="chargeboxId"
                    @input="chargeboxId = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
              <!-- <ion-col size="12" size-md="2">
              <ion-label>Overall Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.overallStatus"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.overallStatus"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Charger Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.otherStatus"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.otherStatus"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col> -->
              <ion-col size="12" size-md="2">
                <br />
                <ion-button class="btn-search margin-top-10" @click="searchBranches">Search</ion-button>
                <ion-button class="btn-clear margin-top-10" @click="clearFields">
                  <ion-icon :icon= "refresh"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row class="row-divider"></ion-row>
        <ion-row class="list-view" v-if="unAvailable">
          <ion-col>
            <ion-row class="list-head">
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Station ID</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1.5">
                <ion-label>Corpoarate Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.7">
                <ion-label>Station Name</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.5">
                <ion-label>City</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>Chargebox ID</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>Output No</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Overall Status</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.2">
                <ion-label>Output Name</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1.2">
                <ion-label>Port Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.7">
                <ion-label>Charger Type</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.5">
                <ion-label>Charger Status</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1.5">
                <ion-label>Error Code</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Date & Time</ion-label>
              </ion-col>
            </ion-row>
            <hr />
  
            <ion-row class="list-item" v-for="(branch) in this.displayList" :key="branch">
              <!-- <ion-col size="12" size-md="1" @click="viewStation(branch)">
                <ion-label class="ext-link">{{branch.stationId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1.5">
                <ion-label>{{branch.corporateName}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.branch}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.7" style="cursor: pointer;" @click="addStationNameInFilter(branch.stationName)">
                <ion-label>{{branch.stationName}}</ion-label>
              </ion-col>
             <ion-col size="12" size-md="1.5" style="cursor: pointer;" @click="addCityInFilter(branch.city)">
                <ion-label>{{branch.city}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2" style="cursor: pointer;" @click="addChargeBoxIdInFilter(branch.chargeBoxID)">
                <ion-label>{{branch.chargeBoxID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>{{branch.outputName}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1.2">
                <ion-label>{{branch.portName}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.7">
                <ion-label>{{branch.chargerTypeDescription}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label v-bind:class="[{'active': branch.rolledupStatus == 'Available'}, {'retired': branch.rolledupStatus == 'Unavailable'},{'charging': branch.rolledupStatus == 'Occupied'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.rolledupStatus == 'Connected'}]">{{convertUppercase(branch.rolledupStatus)}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label class="dec-font" v-bind:class="[{'active': branch.status == 'Available'}, {'retired': branch.status == 'Unavailable' || 'Unregistered'},{'charging': branch.status == 'Charging'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.status == 'Preparing'}]">{{convertUppercase(branch.status)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1.5">
                <ion-label>{{branch.errorCode}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>{{changeDateFormatWithTime(branch.statusTime)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1" v-if="chargingInd && user.roleId == 1">
                <ion-label class="ext-link charging" @click="viewReservationDetails(branch)">View Details</ion-label>
              </ion-col> -->
            </ion-row>
          </ion-col>
        </ion-row>

         <ion-row class="list-view" v-if="faulted">
          <ion-col>
            <ion-row class="list-head">
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Station ID</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1.5">
                <ion-label>Corpoarate Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Station Name</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>City</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Chargebox ID</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output No</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output Name</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Port Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Charger Type</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Overall Status</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.3">
                <ion-label>Charger Status</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>Error Code</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.5">
                <ion-label>Date & Time</ion-label>
              </ion-col>
            </ion-row>
            <hr />
  
            <ion-row class="list-item" v-for="(branch) in this.displayList" :key="branch">
              <!-- <ion-col size="12" size-md="1" @click="viewStation(branch)">
                <ion-label class="ext-link">{{branch.stationId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1.5">
                <ion-label>{{branch.corporateName}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.branch}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5" style="cursor: pointer;" @click="addStationNameInFilter(branch.stationName)">
                <ion-label>{{branch.stationName}}</ion-label>
              </ion-col>
             <ion-col size="12" size-md="1" style="cursor: pointer;" @click="addCityInFilter(branch.city)">
                <ion-label>{{branch.city}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1" style="cursor: pointer;" @click="addChargeBoxIdInFilter(branch.chargeBoxID)">
                <ion-label>{{branch.chargeBoxID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.outputName}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.portName}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>{{branch.chargerTypeDescription}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label v-bind:class="[{'active': branch.rolledupStatus == 'Available'}, {'retired': branch.rolledupStatus == 'Unavailable'},{'charging': branch.rolledupStatus == 'Occupied'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.rolledupStatus == 'Connected'}]">{{convertUppercase(branch.rolledupStatus)}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.3">
                <ion-label class="dec-font" v-bind:class="[{'active': branch.status == 'Available'}, {'retired': branch.status == 'Unavailable' || 'Unregistered'},{'charging': branch.status == 'Charging'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.status == 'Preparing'}]">{{convertUppercase(branch.status)}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>{{branch.errorCode}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.5">
                <ion-label>{{changeDateFormatWithTime(branch.statusTime)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1" v-if="chargingInd && user.roleId == 1">
                <ion-label class="ext-link charging" @click="viewReservationDetails(branch)">View Details</ion-label>
              </ion-col> -->
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="list-view" v-if="chargingInd">
          <ion-col>
            <ion-row class="list-head">
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Station ID</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>Corpoarate Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Station Name</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>City</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Chargebox ID</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output No</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output Name</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Port Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Charger Type</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Overall Status</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Charger Status</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="2">
                <ion-label>Error Code</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Date & Time</ion-label>
              </ion-col>
            </ion-row>
            <hr />
  
            <ion-row class="list-item" v-for="(branch) in this.displayList" :key="branch">
              <!-- <ion-col size="12" size-md="1" @click="viewStation(branch)">
                <ion-label class="ext-link">{{branch.stationId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>{{branch.corporateName}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.branch}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5" style="cursor: pointer;" @click="addStationNameInFilter(branch.stationName)">
                <ion-label>{{branch.stationName}}</ion-label>
              </ion-col>
             <ion-col size="12" size-md="1.2" style="cursor: pointer;" @click="addCityInFilter(branch.city)">
                <ion-label>{{branch.city}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1" style="cursor: pointer;" @click="addChargeBoxIdInFilter(branch.chargeBoxID)">
                <ion-label>{{branch.chargeBoxID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.outputName}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.portName}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>{{branch.chargerTypeDescription}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label v-bind:class="[{'active': branch.rolledupStatus == 'Available'}, {'retired': branch.rolledupStatus == 'Unavailable'},{'charging': branch.rolledupStatus == 'Occupied'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.rolledupStatus == 'Connected'}]">{{convertUppercase(branch.rolledupStatus)}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label v-bind:class="[{'active': branch.status == 'Available'}, {'retired': branch.status == 'Unavailable'},{'charging': branch.status == 'Charging'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.status == 'Preparing'}]">{{convertUppercase(branch.status)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="2">
                <ion-label>{{branch.errorCode}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>{{changeDateFormatWithTime(branch.statusTime)}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1" v-if="userRoleId == 1 || userRoleId == 3">
                <ion-label class="ext-link charging" @click="viewReservationDetails(branch)">View Details</ion-label>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="list-view" v-if="this.available">
          <ion-col>
            <ion-row class="list-head">
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Station ID</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>Corpoarate Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="2">
                <ion-label>Station Name</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>City</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.5">
                <ion-label>Chargebox ID</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output No</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output Name</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Port Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="2">
                <ion-label>Charger Type</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Overall Status</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Charger Status</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Error Code</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Date & Time</ion-label>
              </ion-col> -->
            </ion-row>
            <hr />
  
            <ion-row class="list-item" v-for="(branch) in this.displayList" :key="branch">
              <!-- <ion-col size="12" size-md="1" @click="viewStation(branch)">
                <ion-label class="ext-link">{{branch.stationId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>{{branch.corporateName}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.branch}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addStationNameInFilter(branch.stationName)">
                <ion-label>{{branch.stationName}}</ion-label>
              </ion-col>
             <ion-col size="12" size-md="1" style="cursor: pointer;" @click="addCityInFilter(branch.city)">
                <ion-label>{{branch.city}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.5" style="cursor: pointer;" @click="addChargeBoxIdInFilter(branch.chargeBoxID)">
                <ion-label>{{branch.chargeBoxID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.outputName}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.portName}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="2">
                <ion-label>{{branch.chargerTypeDescription}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label v-bind:class="[{'active': branch.rolledupStatus == 'Available'}, {'retired': branch.rolledupStatus == 'Unavailable'},{'charging': branch.rolledupStatus == 'Occupied'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.rolledupStatus == 'Connected'}]">{{convertUppercase(branch.rolledupStatus)}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label v-bind:class="[{'active': branch.status == 'Available'}, {'retired': branch.status == 'Unavailable'},{'charging': branch.status == 'Charging'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.status == 'Preparing'}]">{{convertUppercase(branch.status)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.errorCode}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1" v-if="chargingInd && user.roleId == 1">
                <ion-label class="ext-link charging" @click="viewReservationDetails(branch)">View Details</ion-label>
              </ion-col> -->
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="list-view" v-if="this.connected">
          <ion-col>
            <ion-row class="list-head">
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Station ID</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>Corpoarate Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Station Name</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>City</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Chargebox ID</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output No</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>Output Name</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Port Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Charger Type</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Overall Status</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.2">
                <ion-label>Charger Status</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Error Code</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>Date & Time</ion-label>
              </ion-col>
            </ion-row>
            <hr />
  
            <ion-row class="list-item" v-for="(branch) in this.displayList" :key="branch">
              <!-- <ion-col size="12" size-md="1" @click="viewStation(branch)">
                <ion-label class="ext-link">{{branch.stationId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>{{branch.corporateName}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.branch}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5" style="cursor: pointer;" @click="addStationNameInFilter(branch.stationName)">
                <ion-label>{{branch.stationName}}</ion-label>
              </ion-col>
             <ion-col size="12" size-md="1.2" style="cursor: pointer;" @click="addCityInFilter(branch.city)">
                <ion-label>{{branch.city}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1" style="cursor: pointer;" @click="addChargeBoxIdInFilter(branch.chargeBoxID)">
                <ion-label>{{branch.chargeBoxID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1">
                <ion-label>{{branch.outputName}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.portName}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>{{branch.chargerTypeDescription}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label v-bind:class="[{'active': branch.rolledupStatus == 'Available'}, {'retired': branch.rolledupStatus == 'Unavailable'},{'charging': branch.rolledupStatus == 'Occupied'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.rolledupStatus == 'Connected'}]">{{convertUppercase(branch.rolledupStatus)}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.2">
                <ion-label v-bind:class="[{'active': branch.status == 'Available'}, {'retired': branch.status == 'Unavailable'},{'charging': branch.status == 'Charging'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.status == 'Preparing'}]">{{convertUppercase(branch.status)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.errorCode}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.5">
                <ion-label>{{changeDateFormatWithTime(branch.statusTime)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1" v-if="chargingInd && user.roleId == 1">
                <ion-label class="ext-link charging" @click="viewReservationDetails(branch)">View Details</ion-label>
              </ion-col> -->
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="list-view" v-if="this.thirdParfty">
          <ion-col>
            <ion-row class="list-head">
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Station ID</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>Corpoarate Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.7">
                <ion-label>Station Name</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>City</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>Chargebox ID</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>Output No</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>Output Name</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Port Name</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="2">
                <ion-label>Charger Type</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Overall Status</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.2">
                <ion-label>Charger Status</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Error Code</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>Date & Time</ion-label>
              </ion-col> -->
            </ion-row>
            <hr />
  
            <ion-row class="list-item" v-for="(branch) in this.displayList" :key="branch">
              <!-- <ion-col size="12" size-md="1" @click="viewStation(branch)">
                <ion-label class="ext-link">{{branch.stationId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="2">
                <ion-label>{{branch.corporateName}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.branch}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.7" style="cursor: pointer;" @click="addStationNameInFilter(branch.stationName)">
                <ion-label>{{branch.stationName}}</ion-label>
              </ion-col>
             <ion-col size="12" size-md="1.2" style="cursor: pointer;" @click="addCityInFilter(branch.city)">
                <ion-label>{{branch.city}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2" style="cursor: pointer;" @click="addChargeBoxIdInFilter(branch.chargeBoxID)">
                <ion-label>{{branch.chargeBoxID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="1.2">
                <ion-label>{{branch.outputName}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.portName}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="2">
                <ion-label>{{branch.chargerTypeDescription}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label v-bind:class="[{'active': branch.rolledupStatus == 'Available'}, {'retired': branch.rolledupStatus == 'Unavailable'},{'charging': branch.rolledupStatus == 'Occupied'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.rolledupStatus == 'Connected'}]">{{convertUppercase(branch.rolledupStatus)}}</ion-label>
              </ion-col> -->
              <ion-col size="12" size-md="1.2">
                <ion-label v-bind:class="[{'active': branch.status == 'Available'}, {'retired': branch.status == 'Unavailable'},{'charging': branch.status == 'Charging'},{'thirdparty': branch.status == 'ThirdParty'},{'connected': branch.status == 'Preparing'}]">{{convertUppercase(branch.status)}}</ion-label>
              </ion-col>
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.errorCode}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1">
                <ion-label>{{branch.connectorID}}</ion-label>
              </ion-col> -->
              <!-- <ion-col size="12" size-md="1" v-if="chargingInd && user.roleId == 1">
                <ion-label class="ext-link charging" @click="viewReservationDetails(branch)">View Details</ion-label>
              </ion-col> -->
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="row-divider"></ion-row>
        <ion-row v-if="norecordsfound">
          <ion-col size="12" text-center>
            <ion-label class="pagination-info">No records found for the selected filters</ion-label>
          </ion-col>
        </ion-row>
        <ion-row v-else>
          <ion-col size="12" size-md="5">
            <ion-label
              class="pagination-info"
            >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
            
          </ion-col>
          <ion-col size="12" size-md="7" class="ion-text-right">
            <div class="pagination">
              <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
              <a class="prev disabled" v-else>Prev</a>
              <a
                v-for="page in this.pagesList"
                :key="page"
                v-bind:class="{'active': pageNo == page}"
                @click="loadPage(page)"
              >{{page}}</a>
              <a
                class="next"
                v-if="this.pageNo < this.totalPages"
                @click="loadPage(pageNo + 1)"
              >Next</a>
              <a class="next disabled" v-else>Next</a>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
      </div>
    </div>
</template>

<script>
import { defineComponent } from "vue"
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { refresh } from 'ionicons/icons';
import moment from "moment";

export default defineComponent ({
  name: 'chargerStatusList',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      corporates: [],
      statuses: [],
      corporateId: "",
      corporateName: "",
      branch: "",
      gstNumber: "",
      status: "",
      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 10,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,
      userRoleId: '',
      branchId: "",
      branchList: [],
      displayList: [],
      displayChargingStatus: false,
      overallStatus: [],
      otherStatus: [],
      chargingInd: false,
      reservationDetails: "",
      stationName: "",
      chargeboxId : "",
      available: false,
      unAvailable: false,
      connected: false,
      faulted: false,
      thirdParfty: false,
      city: "",
      filteredList: [],
      isFiltered: false,
      chargerStatusData: "",
      filteredData: ""
    }
  },
  async mounted() {
    this.userRoleId = localStorage.getItem("user.roleId")
    this.loadInitialData();
    
  },
  methods: {
    addStationNameInFilter(stationName) {
        document.getElementById('stationName').value = stationName;
        this.stationName = stationName;
    },
    addCityInFilter(city) {
        document.getElementById('city').value = city;
        this.city = city;
    },
    addChargeBoxIdInFilter(chargeboxId) {
        document.getElementById('chargeboxId').value = chargeboxId;
        this.chargeboxId = chargeboxId;
    },
    changeDateFormatWithTime(dateValue) {  
      if(dateValue != null || dateValue != undefined) {
          return moment(dateValue).format('DD/MMM/YYYY HH:mm:ss')
      }
    },
    async loadInitialData() {
      // this.overallStatus = await new CorporateService().getChargerOverallStatus();
      // this.otherStatus = await new CorporateService().getChargerOtherStatus();
      this.chargerStatusData = JSON.parse(localStorage.getItem('chargerStatusData'));
      var page = localStorage.getItem('branchPage');
      if(page) {
        this.pageNo = Number(page);
      }
      var search = localStorage.getItem('branchSearch');
      if(search) {
        search = JSON.parse(search);
        this.stationName = search.stationName;
        this.city = search.city;
        this.chargeboxId = search.chargeboxId;
        await this.searchBranches();
      } else {
        this.branchList = this.chargerStatusData;
        this.totalRecords = this.branchList.length;

        this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          this.pageNo
        );
        this.totalPages = new PaginationUtils().getTotalPages(
          this.totalRecords,
          this.pageRecords
        );
        const pageData = { recordNumber: 0, records: 9999999999 };
        pageData.records = parseInt(this.pageRecords);
        pageData.recordNumber = parseInt((pageData.records * parseInt((this.pageNo - 1))));
        this.displayList = this.branchList.slice(pageData.recordNumber,(pageData.records*this.pageNo));
        // console.log("this.display list" + JSON.stringify(this.displayList))
        this.norecordsfound = false;
        this.loaderTab = false;
      }

      // let statusData = JSON.parse(localStorage.getItem('chargerStatusData'))
      // if(statusData) {
      //   this.branchList = statusData;
      //   this.totalRecords = this.branchList.length;
      //   this.pagesList = new PaginationUtils().getPagesList(
      //     this.totalRecords,
      //     this.pageRecords,
      //     this.pageNo
      //   );
      //   this.totalPages = new PaginationUtils().getTotalPages(
      //     this.totalRecords,
      //     this.pageRecords
      //   );
      //   this.displayList = this.branchList.slice(0,this.pageRecords)
      //   if(this.branchList) {
      //     localStorage.setItem('selectedBranchList', JSON.stringify(this.branchList))
      //     this.norecordsfound = false;
      //   }
      //   this.loaderTab = false;
      // }
      // if(localStorage.getItem('selectedBranchList')) {
      //   this.branchList = JSON.parse(localStorage.getItem('selectedBranchList'));
      //   this.norecordsfound = false;
      //   this.loaderTab = false;
      // }

      // var page = localStorage.getItem('branchPage');
      // if(page) {
      //   this.pageNo = Number(page);
      // }
      
      // var search = localStorage.getItem('branchSearch');
      // if(search) {
      //   search = JSON.parse(search);
      //   this.stationName = search.stationName;
      //   this.city = search.city;
      //   this.chargeboxId = search.chargeboxId;
      //   // document.getElementById("stationName").value = search.stationName;
      //   // document.getElementById("city").value = search.city;
      //   // document.getElementById("chargeboxId").value = search.chargeboxId;
      //   await this.searchBranches();
      // } 

      var dataType = localStorage.getItem('dataType');
      if(dataType == 'Occupied') {
        this.chargingInd = true;
      }
      if(dataType == 'Available') {
        this.available = true;
      }
      if(dataType == 'Unavailable') {
        this.unAvailable = true;
      }
      if(dataType == 'Connected') {
        this.connected = true;
      }
      if(dataType == 'Faulted') {
        this.faulted = true;
      }
      if(dataType == 'ThirdParfty') {
        this.thirdParfty = true;
      }
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    viewBranchDetails(corporateInfo) {
      localStorage.removeItem('userBranchSearch');
      // let save data in local storage 13052022
      let branchInfo = {
        corporateId: corporateInfo.corporateId,
        branchId: corporateInfo.branchId,
        corporateName: corporateInfo.corporateName,
        branch: corporateInfo.branch
      }
      localStorage.setItem('branchInfo', JSON.stringify(branchInfo));
      this.$router.push({
        name: "branchDetails",
        params: { corporateId: corporateInfo.branchId }
      });
    },
    viewStation(corporateInfo) {
      if(this.userRoleId != 6 && this.userRoleId !=5 && this.userRoleId != 4 && this.userRoleId != 3) {
        localStorage.removeItem('userBranchSearch');
        // let save data in local storage 13052022
        let branchInfo = {
          corporateId: corporateInfo.corporateId,
          branchId: corporateInfo.branchId,
          corporateName: corporateInfo.corporateName,
          branch: corporateInfo.branch
        }
        localStorage.setItem('branchInfo', JSON.stringify(branchInfo));
        
        localStorage.setItem("stationIdForView", corporateInfo.stationId);
        this.$router.push({
            name: "chargingStationView",
            params: { stationId: corporateInfo.stationId }
        });
      } 
      
    },
    clearFields() {
      this.stationName = null;
      this.city = null;
      this.chargeboxId = null;
      document.getElementById("stationName").value = "";
      document.getElementById("city").value = "";
      document.getElementById("chargeboxId").value = "";
      this.displayList = [];
      this.norecordsfound = true;
      localStorage.removeItem("branchSearch");
      localStorage.removeItem("filteredData");
      localStorage.removeItem('branchPage');
      this.pageNo = 1;
      this.loadInitialData();
    },
    areFiltersEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    async searchBranches() {
      try {
        // localStorage.removeItem('branchPage');
        let searchFilterData = {
          stationName: this.stationName,
          city: this.city,
          chargeboxId: this.chargeboxId,
        }
        var search = JSON.parse(localStorage.getItem('branchSearch'));
        if(!this.areFiltersEqual(searchFilterData, search)) {
          localStorage.setItem("branchSearch",JSON.stringify(searchFilterData));
          this.pageNo = 1;
          localStorage.setItem('branchPage', this.pageNo);
        } else {
          let pageNo = localStorage.getItem('branchPage');
          if(pageNo) {
            this.pageNo = pageNo;
          } else {
            this.pageNo = 1;
          }
        }
        // const stationNameInput = document.getElementById('stationName');
        // const cityInput = document.getElementById('city');
        // const chargeboxIdInput = document.getElementById('chargeboxId');

        // const stationName = String(stationNameInput?.value || '').trim().toLowerCase();
        // const city = String(cityInput?.value || '').trim().toLowerCase();
        // const chargeboxId = String(chargeboxIdInput?.value || '').toString().trim();

        const stationName = (this.stationName || '').trim().toLowerCase();
        const city = (this.city || '').trim().toLowerCase();
        const chargeboxId = (this.chargeboxId || '').toString().trim();
        // original
        // const filtered = this.branchList.filter(cb => {
        //   const matchesChargeBox = cb.chargeBoxID.toString().includes(chargeboxId);
        //   const matchesStation = cb.stationName.toLowerCase().includes(stationName);
        //   const matchesCity = cb.city.toLowerCase().includes(city);
        //   return matchesChargeBox && matchesStation && matchesCity;
        // });
        this.filteredData = this.chargerStatusData.filter(cb => {
          const matchesChargeBox = cb.chargeBoxID.toString().includes(chargeboxId);
          const matchesStation = cb.stationName.toLowerCase().includes(stationName);
          const matchesCity = cb.city.toLowerCase().includes(city);
          return matchesChargeBox && matchesStation && matchesCity;
        });
        localStorage.setItem('filteredData', JSON.stringify(this.filteredData))
        // this.displayList = filtered
        this.totalRecords = this.filteredData.length;
        // this.pageNo = 1;
        this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          this.pageNo
        );
        this.branchList = this.filteredData;
        const pageData = { recordNumber: 0, records: 9999999999 };
        try{
          // console.log(JSON.stringify(filtered))
          pageData.records = parseInt(this.pageRecords);
          pageData.recordNumber = parseInt((pageData.records * parseInt((this.pageNo - 1))));
          this.displayList = this.branchList.slice(pageData.recordNumber,(pageData.records*this.pageNo));
          this.norecordsfound = false;
          this.loaderTab = false;
        }catch(error){
          console.log("Pagination Error: ", error);
        }
      } catch(error) {
        alert(error)
      }
    },

    async loadPage(page) {
      localStorage.setItem('branchPage', page);
      this.loaderTab = true;
      this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );

      const pageData = { recordNumber: 0, records: 9999999999 };
      try{
        pageData.records = parseInt(this.pageRecords);
        pageData.recordNumber = parseInt((pageData.records * parseInt((page - 1))));
        this.filteredData = JSON.parse(localStorage.getItem('flteredData'))
        // if(this.filteredData) {
        //   this.displayList = this.filteredData.slice(pageData.recordNumber,(pageData.records*page));
        // } else {
        //   this.displayList = this.branchList.slice(pageData.recordNumber,(pageData.records*page));
        // }
        this.displayList = this.branchList.slice(pageData.recordNumber,(pageData.records*page));
        this.norecordsfound = false;
        this.loaderTab = false;
      }catch(error){
        console.log("Pagination Error: ", error);
      }
      
    },
    async viewReservationDetails(branchInfo) {
      this.reservationDetails = await new CorporateService().getReservatinDetailsForSelectedBranchQuery(branchInfo);
      if(this.reservationDetails.length != 0) {
        this.$router.push({
          name: "reservationView",
          params: { reservationId: this.reservationDetails[0].reservationId },
        });
      } else {
        new ToastUtils().presentToast("There is no data, refresh the data in dashboard");
      }
    
    }

  }
})
</script>

<style scoped>
  .dec-font {
    font-size: 10px;
  }
  .select-box {
    position: relative;
    max-width: 317px;
    width: 100%;
    display: inline-block;
    margin-right: 16px;
  }
  
  .select-box ion-select {
    max-width: 317px;
    width: 100%;
    height: 34px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    border-radius: 4px;
    opacity: 1;
    padding: 12px;
    padding-top: 13px;
    text-align: left;
    font-size: 14px;
    font-family: "Roboto Medium";
    letter-spacing: 0;
    line-height: 26px;
    color: #202020;
  }
  
  .select-box .custom-select-placeholder {
    font-size: 14px;
    font-family: "Roboto Medium";
    letter-spacing: 0;
    color: #202020;
    opacity: 1;
    position: absolute;
    z-index: 99;
    top: 18px;
    left: 18px;
  }
  
  .select-box .custom-select-icon {
    position: absolute;
    z-index: 99;
    top: 6px;
    background: #fff;
    right: 15px;
  }
  .thirdParty{
    padding-left: 10px;
    padding-right: 10px;
    width: 100px !important;
    background: #e27b7b 0% 0% no-repeat padding-box;
    border-radius: 3px;
    text-align: center;
    font-family: "Roboto";
    font-size: 11px;
    letter-spacing: 0;
    color: #ffffff;
    opacity: 1;
  }
  </style>